import getCdnUrl from '../../helpers/get-cdn-url';

const CommissionEquation = getCdnUrl('/common_assets/commission_equation.webp');

export default CommissionEquation;
